import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';

import Paragraph from 'ui/Paragraph';
import * as valid from 'utils/validators';
import { generateUUID } from 'utils/random';
import { PasswordField } from '../common/PasswordField';

import { verifiCredentials } from './services';
import { withStyles, Typography } from '@material-ui/core';
import { isVerifiedAzureConnector } from '../Consts';

const FORM_VALIDATORS = valid.rules([
    valid.notEmpty('client_id'),
    valid.notEmpty('client_secret'),
    valid.notEmpty('tenant'),
]);

const validateForm = data => valid.validate(FORM_VALIDATORS, data);

const openWindow = url => {
    const requestKey = `azure.callback.${generateUUID()}`;
    const loginWindow = window.open(url, requestKey);
    // const loginWindow = '';
    return new Promise((resolve, reject) => {
        // resolve();
        // return;

        function checkWindow() {
            if (!loginWindow.closed) {
                setTimeout(() => checkWindow(loginWindow), 200);
                return;
            }
            const status = localStorage.getItem(requestKey);
            localStorage.removeItem(requestKey);
            if (status === 'success') {
                resolve();
            } else {
                reject();
            }
        }
        checkWindow();
    });
};

function statusState(isVerified) {
    const STATUS_INIT = 0;
    const STATUS_VERIFIED = 1;
    const STATUS_FAILED = 2;
    const STATUS_LOADING = 4;
    const STATUS_CHECKED = 3;

    const init = isVerified ? STATUS_VERIFIED : STATUS_INIT;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [status, setStatus] = useState(init);

    return {
        get value() {
            return status;
        },
        isLoading() {
            return !!(status & STATUS_LOADING);
        },
        isChecked() {
            return !!(status & STATUS_CHECKED);
        },
        isVerified() {
            return !!(status & STATUS_VERIFIED);
        },
        isFailed() {
            return !!(status & STATUS_FAILED);
        },
        reset() {
            setStatus(STATUS_INIT);
        },
        loading() {
            setStatus(status | STATUS_LOADING);
        },
        loaded() {
            setStatus(status & ~STATUS_LOADING);
        },
        verified() {
            setStatus(STATUS_VERIFIED);
        },
        failed() {
            setStatus(STATUS_FAILED);
        },
    };
}

export default ({ mode, tabs, connector, values, onChange }) => {
    const editable = mode !== 'details';
    const isVerified = mode === 'edit' && isVerifiedAzureConnector(connector);
    const status = statusState(isVerified);
    const [errors, setErrors] = useState({});
    const extra = values.extra || {
        client_id: '',
        client_secret: '',
        tenant: '',
    };

    const changeFactory = name => value => {
        status.reset();
        tabs.lock();
        onChange('extra', { ...extra, ...{ [name]: value.trim() } });
    };
    const onVerify = () => {
        status.reset();
        tabs.lock();
        validateForm(extra).then(errors => {
            if (errors) {
                setErrors(errors);
            } else {
                setErrors({});
                status.loading();
                verifiCredentials(connector.uuid, extra).then(url => {
                    status.loaded();
                    if (url) {
                        openWindow(url)
                            .then(() => {
                                tabs.unlock();
                                status.verified();
                            })
                            .catch(() => status.failed());
                    } else {
                        status.failed();
                    }
                }, 1000);
            }
        });
    };
    useEffect(() => {
        if (!status.isVerified()) {
            tabs.lock();
        }
        return () => tabs.unlock();
    }, []);

    return (
        <React.Fragment>
            <Paragraph>
                Please provide the following information from Azure to configure
                the connector.
            </Paragraph>
            <FormRow>
                <PasswordField
                    label="Client ID"
                    value={extra.client_id}
                    disabled={!editable}
                    error={errors.client_id}
                    onChange={changeFactory('client_id')}
                />
            </FormRow>
            <FormRow>
                <PasswordField
                    label="Client Secret Value"
                    value={extra.client_secret}
                    disabled={!editable}
                    error={errors.client_secret}
                    onChange={changeFactory('client_secret')}
                />
            </FormRow>
            <FormRow>
                <PasswordField
                    label="Tenant"
                    value={extra.tenant}
                    disabled={!editable}
                    error={errors.tenant}
                    onChange={changeFactory('tenant')}
                />
            </FormRow>
            {editable && <StatusAction status={status} onVerify={onVerify} />}
        </React.Fragment>
    );
};

const styles = theme => ({
    statusAction: {
        marginTop: theme.spacing(),
    },
    statusMessage: {
        display: 'inline-block',
        margin: `${theme.spacing()}px ${theme.spacing(2)}px`,
    },
    statusMessageSuccess: {
        color: '#76ab53',
    },
    statusMessageError: {
        color: '#f00',
    },
    verifyButton: {
        color: '#fff !important',
        background: '#76ac53',
        padding: '6px 16px',
        '&:hover': {
            opacity: 0.7,
            background: '#76ac53',
        },
    },
});

const StatusAction = withStyles(styles)(({ status, onVerify, classes }) => {
    return (
        <div className={classes.statusAction}>
            <Button
                color="secondary"
                onClick={onVerify}
                className={classes.verifyButton}
            >
                Verify connection
            </Button>
            <div className={classes.statusMessage}>
                <Typography>
                    {status.isLoading() && <span>Loading...</span>}
                    {status.isVerified() && (
                        <span className={classes.statusMessageSuccess}>
                            Connection verfied
                        </span>
                    )}
                    {status.isFailed() && (
                        <span className={classes.statusMessageError}>
                            Connection failed
                        </span>
                    )}
                </Typography>
            </div>
        </div>
    );
});

const FormRow = withStyles(theme => ({
    root: {
        marginTop: 16,
        marginBottom: 16,
    },
}))(({ classes, children }) => <div className={classes.root}>{children}</div>);
